// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"24c1a7c2","191":"6439e6b6","453":"dd231a6c","538":"fa8e9c06","555":"8597473a","615":"e2b721c8","818":"bef2a2e5","891":"42191d51","900":"60a46ac8","936":"b329d41b"}[chunkId] + ".chunk.js";
};